/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { TablePagination } from "@mui/material";
import Switch from "@mui/material/Switch";
import { getAssets, toAbsoluteUrl } from "@unisearch/helpers";
import Link from "next/link";
import React, { Fragment } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  MdDelete,
  MdDeleteForever,
  MdLaunch,
  MdModeEdit,
  MdMoreVert,
  MdRestore,
} from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { AiOutlineEye } from "react-icons/ai";
import { ReactSVG } from "react-svg";

//Status list
export const actionStatus = {
  Draft: "Draft",
  Publish: "Published",
  Trash: "Trash",
  Deleted: "Trash",
  Active: "Published",
  Inactive: "Inactive",
};

//Sort Caret
export const sortCaret = (order, column) => {
  if (!order)
    return (
      <span className="svg-icon svg-icon-sm svg-icon-primary ml-1 svg-icon-sort">
        <ReactSVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Sort1.svg")} />
      </span>
    );
  else if (order === "asc")
    return (
      <span className="svg-icon svg-icon-sm svg-icon-primary ml-1">
        <ReactSVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Up-2.svg")} />
      </span>
    );
  else if (order === "desc")
    return (
      <span className="svg-icon svg-icon-sm svg-icon-primary ml-1">
        <ReactSVG
          src={toAbsoluteUrl("/media/svg/icons/Navigation/Down-2.svg")}
        />
      </span>
    );
  return null;
};

//Handle Sorting Class
export const headerSortingClasses = (
  column,
  sortOrder,
  isLastSorting,
  colIndex
) => (sortOrder === "ASC" || sortOrder === "DESC" ? "sortable-active" : "");

//Alignment Formater
export const FormatAlignment = (value, row, align = "left") => {
  return <span className={`d-block text-${align}`}>{value}</span>;
};

//image filter
export const FormateImage = (value, row, size = 50) => {
  return (
    <span className="images">
      <img src={value ?? "/images/image.png"} alt="" width={size ?? 50} />
    </span>
  );
};

//Status Column Filter
export const StatusColumnFormatter = (cell, row) => {
  const getLabelCssClasses = () => {
    return `statusLabel ${actionStatus[cell]}`;
  };
  return <span className={getLabelCssClasses()}>{actionStatus[cell]}</span>;
};

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    viewAction = false,
    detailAction = false,
    editAction = false,
    deleteAction = false,
    restoreAction = false,
    customComponent = false,
    customDropdown = false,
    viewMediaAction = false,
  }
) => {
  return (
    <Fragment>
      <div className="table_cell_action" key={row.id}>
        <div
          className={`admin_action_button_wrapper`}
          style={{ justifyContent: "flex-end" }}
        >
          {viewAction && (
            <a
              title="View Details"
              className={`admin_action_button hover_blue`}
              onClick={(e) => {
                e.preventDefault();
                viewAction(row);
              }}
            >
              <MdLaunch />
            </a>
          )}

          {detailAction && (
            <a
              title="View Details"
              className={`admin_action_button hover_blue`}
              onClick={(e) => {
                e.preventDefault();
                detailAction(row);
              }}
            >
              <IoEyeOutline fontSize="16px" />
            </a>
          )}
          {viewMediaAction && (
            <a
              title="View"
              target="_blank"
              href={row.src}
              rel="noopener"
              className={`admin_action_button hover_blue`}
            >
              <IoEyeOutline fontSize="16px" />
            </a>
          )}

          {customComponent ? customComponent(row) : ""}

          {(editAction || deleteAction || customDropdown) && (
            <div
              className="action_more_dropdown_wrapper"
              style={{ marginLeft: "unset" }}
            >
              <MdMoreVert
                className="table_cell_action_more"
                style={{ marginTop: "4px" }}
              />
              <div className={`action_more_dropdown`}>
                <ul>
                  {editAction && row.status != "Deleted" && (
                    <li
                      onClick={(e) => {
                        e.preventDefault();
                        editAction(row);
                      }}
                    >
                      <MdModeEdit className="action_more_dropdown_icon" />
                      <span>Edit</span>
                    </li>
                  )}

                  {restoreAction && row.status == "Deleted" && (
                    <li
                      onClick={() => {
                        restoreAction(row);
                      }}
                    >
                      <MdRestore className="action_more_dropdown_icon" />
                      <span>Restore</span>
                    </li>
                  )}

                  {deleteAction && row.status != "Deleted" && (
                    <li
                      onClick={() => {
                        deleteAction(row);
                      }}
                    >
                      <MdDelete className="action_more_dropdown_icon" />
                      <span>Trash</span>
                    </li>
                  )}
                  {deleteAction && row.status == "Deleted" && (
                    <li
                      onClick={() => {
                        deleteAction(row);
                      }}
                    >
                      <MdDeleteForever className="action_more_dropdown_icon" />
                      <span>Delete</span>
                    </li>
                  )}
                  {customDropdown ? customDropdown(row) : ""}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

//update switcher actions
export const switcherActions = (
  cellcontent,
  row,
  rowIndex,
  { handleAction }
) => {
  return (
    <Switch
      checked={cellcontent && cellcontent == 1 ? true : false}
      onChange={(e) => handleAction(e, row)}
      inputProps={{ "aria-label": "controlled" }}
      size="small"
    />
  );
};

//update status actions
export const statusActions = (cellcontent, row, rowIndex, { handleAction }) => {
  return (
    <Switch
      checked={cellcontent && cellcontent == 1 ? true : false}
      onChange={(e) => handleAction(e, row)}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
};

//row selection
export const RowSelection = (data, setstate, id) => {
  return {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    selected: data,
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        setstate((item) => [...item, row[id]]);
      } else {
        setstate(data.filter((item) => item != row[id]));
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        setstate(
          rows.map((item) => {
            return item[id];
          })
        );
      } else {
        setstate([]);
      }
    },
  };
};

//Pagination Helpers
export const customPagination = (paginationInfo, paginationHandler) => {
  //pagination factgory
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  if (paginationInfo?.totalRows) {
    return paginationFactory({
      page: paginationInfo.currentPage,
      paginationSize: 4,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      totalSize: paginationInfo?.totalRows,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        {
          text: "5",
          value: 5,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "All",
          value: paginationInfo?.totalRows,
        },
      ],
      onSizePerPageChange: (sizePerPage, page) => {
        if (paginationHandler) {
          console.log(sizePerPage, page);
          paginationHandler({ pageSize: sizePerPage, pageNumber: page });
        }
      },
      onPageChange: (page, sizePerPage) => {
        console.log(sizePerPage, page);
        if (paginationHandler) {
          paginationHandler({ pageSize: sizePerPage, pageNumber: page });
        }
      },
    });
  }
};

//Top Pagination Handler
export const TopPaginationHandler = ({
  paginationInfo,
  paginationHandler,
  customClasses,
  ...props
}) => {
  const handlePager = (e, page) => {
    paginationHandler("pagination", {
      sizePerPage: paginationInfo.limit,
      page: parseInt(page) + 1,
    });
  };
  if (paginationInfo?.totalRows > 0) {
    return (
      <Fragment>
        Showing:
        {paginationInfo &&
          paginationInfo.totalRows &&
          paginationInfo.currentPage && (
            <TablePagination
              backIconButtonProps={{
                disableRipple: true,
              }}
              nextIconButtonProps={{
                disableRipple: true,
              }}
              rowsPerPageOptions={[]}
              classes={{
                root: `${customClasses?.root ? customClasses.root : ""}`,
                toolbar: `${
                  customClasses?.toolbar ? customClasses.toolbar : ""
                }`,
                actions: `${
                  customClasses?.actions ? customClasses.actions : ""
                }`,
              }}
              count={paginationInfo.totalRows}
              page={parseInt(paginationInfo.currentPage) - 1}
              rowsPerPage={paginationInfo.limit}
              onPageChange={handlePager}
              component="div"
            />
          )}
      </Fragment>
    );
  }
  return <></>;
};

export const UniTableComponent = ({
  data = [],
  columns = [],
  keyField = "id",
  pagination = false,
  onTableChange,
  selectRow,
}) => {
  //pagination info
  const page = pagination?.currentPage ?? 1;
  const sizePerPage = pagination?.limit ?? 10;
  const totalSize = pagination?.totalRows ?? 0;
  if (pagination) {
    return (
      <BootstrapTable
        remote
        keyField={keyField}
        data={data}
        columns={columns}
        pagination={paginationFactory({ page, sizePerPage, totalSize })}
        onTableChange={onTableChange}
        selectRow={selectRow}
      />
    );
  }

  return (
    <BootstrapTable
      remote
      keyField={keyField}
      data={data}
      columns={columns}
      onTableChange={onTableChange}
      selectRow={selectRow}
    />
  );
};

//name column formater
export const NameColumnFormatter = (row) => {
  const renderData = () => {
    return (
      <div className="table-profile">
        <div className="profile-image">
          <img
            src={
              row?.profileImage || getAssets("assets/student-avatar-small.png")
            }
            alt={row?.name ?? ""}
          />
        </div>
        <div className="profile-content">
          {row?.name && <span className="profile-name"> {row.name}</span>}
          {row?.role && (
            <span className="profile-designation"> {row.role}</span>
          )}
          {row?.designation && (
            <span className="profile-designation"> {row.designation}</span>
          )}
          {row?.subDesignation && (
            <span className="profile-subDesignation">{row.subDesignation}</span>
          )}
          {row?.email && <span className="profile-email"> {row.email}</span>}
        </div>
      </div>
    );
  };

  if (row?.link) {
    return (
      <Link legacyBehavior href={row?.link}>
        <a>{renderData()}</a>
      </Link>
    );
  } else {
    return renderData();
  }
};

//name column formater
export const FileColumnFormater = (data = false) => {
  if (!data)
    return (
      <div className="tableImage">
        <img src="/assets/images/vector-image.png" alt="" />
      </div>
    );

  var extension = data.split(".").pop();

  if (extension == "pdf") {
    return (
      <div className="tableFileIcon">
        <ReactSVG src={getAssets("assets/icons/pdf_icon.svg")} />
      </div>
    );
  }
  if (extension == "xlsx" || extension == "xls") {
    return (
      <div className="tableFileIcon">
        <ReactSVG src={getAssets("assets/icons/xls_icon.svg")} />
      </div>
    );
  }
  if (extension == "docx" || extension == "doc") {
    return (
      <div className="tableFileIcon">
        <ReactSVG src={getAssets("assets/icons/doc_icon.svg")} />
      </div>
    );
  }
  if (extension == "mp4") {
    return (
      <div className="tableVideo">
        <video width="100%" height="180" controls="controls" preload="none">
          <source src={imageUrl} type="video/mp4" autostart="false" />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }
  if (
    extension == "jpg" ||
    extension == "jpeg" ||
    extension == "png" ||
    extension == "webp" ||
    extension == "svg"
  ) {
    return (
      <div className="tableImage">
        <img src={data} alt="" />
      </div>
    );
  }

  return (
    <div className="tableImage">
      <img src={data} alt="" />
    </div>
  );
};
